import React from 'react';
import PropTypes from 'prop-types';
import {Dropdown} from '@learningblocks/shared-components/lib/Dropdown';
import {OpenIcon, CloseIcon} from './Icons';

import style from './style.module.scss';
import {GlossaryDispatch} from '../../Glossary';
/**
 * CategoryDropdown:
 *   - The dropdown component to list the number of categories
 */
export function CategoryDropdown(props) {
  const {onTabSelect: onDropDownChange} = React.useContext(GlossaryDispatch);

  return (
    <Dropdown
      className={style.dropdown}
      defaultValue={props.categories[0].value}
      onChange={onDropDownChange}
      options={props.categories}
      iconOpen={OpenIcon}
      iconClose={CloseIcon}
    />
  );
}

CategoryDropdown.propTypes = {
  /**
   * list of categories to be displayed
   */
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * label to be displayed in dropdown
       */
      label: PropTypes.string,
      /**
       * unique identification
       */
      optionID: PropTypes.number,
      /**
       * value of option
       */
      value: PropTypes.string,
    }),
  ),
};

CategoryDropdown.defaultProps = {};
